import { useTranslation } from 'react-i18next';
import useHorizontalCarousel from '../Compartido/useHorizontalCarousel';
import '../../../../../css/web/bedloophotel/ventajas.css';

const Ventajas = ({ ventajas, ruta }) => {

    const { t } = useTranslation();

    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.bh-ventaja', ventajas.length);

    return (
        <>
            {
                ventajas.length > 0 ?
                    <div className="bh-ventajas">
                        <div className="container">
                            <h1 className="bh-ventajas__title">{t("Ventajas")}</h1>
                        </div>

                        <div className="bhh-destacados__carousel">
                            <button
                                type="button"
                                disabled={navState.atStart}
                                onClick={() => scrollByCard(-1)}
                                className="bhh-destacados__prev"
                                aria-label={t("Anterior")}
                            >
                                <i className="fa-solid fa-arrow-left"></i>
                            </button>
                            <div className="bh-ventajas__track" ref={trackRef}>
                                {ventajas.map((ventaja) => (
                                    <div className="bh-ventaja" key={ventaja.id}>
                                        <div className="bh-ventaja__card">
                                            <div className="bh-ventaja__media">
                                                <img src={`${ruta}/ventajas/${ventaja.id}/${ventaja.imagen}`} alt={ventaja.elnombre} loading="lazy" />
                                            </div>
                                            <div className="bh-ventaja__body">
                                                <h3 className="bh-ventaja__titulo">{ventaja.elnombre}</h3>
                                                <div className="bh-ventaja__desc" dangerouslySetInnerHTML={{ __html: ventaja.eltexto }}></div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <button
                                type="button"
                                disabled={navState.atEnd}
                                onClick={() => scrollByCard(1)}
                                className="bhh-destacados__next"
                                aria-label={t("Siguiente")}
                            >
                                <i className="fa-solid fa-arrow-right"></i>
                            </button>
                        </div>
                    </div>
                    :
                    ""
            }
        </>
    );
}

export default Ventajas;
